import UploadFileDialog from './UploadFileDialog.view';
export default UploadFileDialog;
